/* eslint-disable no-case-declarations */
import * as nursingNoteTypes from '../types/nursingNoteTypes';
import initialState from './initialState';
import { updateObject } from 'utils';

const nursingNotes = (state = initialState.nursingNotes, { type, payload }) => {
  switch (type) {
    case nursingNoteTypes.ADD_NOTE_START:
      return updateObject(state, { isSaving: true });

    case nursingNoteTypes.ADD_NOTE_END:
      return updateObject(state, { isSaving: false });

    case nursingNoteTypes.FETCH_PROGRESS_NOTES_SUCCESS:
      return updateObject(state, { progressNoteItems: payload });

    case nursingNoteTypes.ADD_PROGRESS_NOTE_SUCCESS:
      return updateObject(state, {
        progressNoteItems: (state.progressNoteItems || []).concat(payload),
        isSaving: false,
      });

    default:
      return { ...state };
  }
};

export default nursingNotes;
